import { useApiAccountsV1SignoutCreate, useCurrentUser } from 'api';
import { useNavigate } from 'react-router-dom';
import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Skeleton, Stack, Typography } from 'ui';
import { Logout, PersonOutline, Settings } from 'ui/icons';

export const UserMenu = () => {
  const { data: user, isLoading } = useCurrentUser();
  const navigate = useNavigate();
  const { mutate: logOut } = useApiAccountsV1SignoutCreate();

  return (
    <Menu
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom',
      }}
      disableScrollLock
      transformOrigin={{
        horizontal: 'right',
        vertical: 'top',
      }}
      equalMenuWidth={false}
      button={
        <IconButton size="small" color="primary">
          <PersonOutline />
        </IconButton>
      }
    >
      <Stack
        sx={(theme) => ({
          borderBottom: `1px solid ${theme.palette.border.main}`,
          px: 2,
          py: 1,
        })}
      >
        {isLoading ? (
          <>
            <Skeleton variant="text" />
            <Skeleton variant="text" />
          </>
        ) : (
          <>
            <Typography variant="body1">{user?.full_name}</Typography>
            <Typography variant="body2" color="text.secondary">
              {user?.company.trade_company.name}
            </Typography>
          </>
        )}
      </Stack>
      <MenuItem component="a" href="/accounts/manage_company/">
        <ListItemIcon>
          <Settings fontSize="small" />
        </ListItemIcon>
        <ListItemText>Manage company</ListItemText>
      </MenuItem>
      <MenuItem
        onClick={() => {
          logOut();
          navigate('/accounts/auth/sign-in/');
        }}
      >
        <ListItemIcon>
          <Logout />
        </ListItemIcon>
        <ListItemText>Log out</ListItemText>
      </MenuItem>
    </Menu>
  );
};
